import { useContext } from "react";
import { useMutation, useQueryClient } from "react-query";
import { AuthContext } from "../../Context/AuthContext";

const rejectPackageByRider = async (riderAssignmentId, token) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/packages/rejectpackagerider/${riderAssignmentId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to reject package");
    }

    return response.json();
  } catch (error) {
    throw new Error(error.message);
  }
};

const useRejectPackageByRider = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  return useMutation((riderAssignmentId) => rejectPackageByRider(riderAssignmentId, token), {
    onSuccess: () => {
      queryClient.invalidateQueries("riderAssignment");
    },
  });
};

export default useRejectPackageByRider;
